<div class="media-library-shell">
  <div class="media-library-main">
    <div class="media-library-toolbar">
      <div class="toolbar-meta">
        <div class="panel-title">Library</div>
        <div class="panel-copy">{{ imageIds.length }} loaded</div>
      </div>

      <div class="toolbar-actions">
        @if (selected) {
          <div class="selected-info">
            <div class="label">ID: {{ selected }}</div>
            @if (isPickerMode) {
              <button mat-raised-button color="primary" (click)="choose()">Use selected</button>
            }
          </div>
        }

        @if (!isPickerMode) {
          <button mat-raised-button color="primary" (click)="openAddMediaDialog()">
            Add media
          </button>
        }
      </div>
    </div>

    <div class="media-library-filters">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search media ID</mat-label>
        <input
          matInput
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchInput($event)"
          placeholder="Type to filter..."
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="sort-field">
        <mat-label>Sort by</mat-label>
        <mat-select [(ngModel)]="sort" (selectionChange)="onSortChange()">
          <mat-option value="createdAt-dsc">Created (Newest first)</mat-option>
          <mat-option value="createdAt-asc">Created (Oldest first)</mat-option>
          <mat-option value="id-asc">ID (A to Z)</mat-option>
          <mat-option value="id-dsc">ID (Z to A)</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="images-container">
      @if (imageIds.length > 0) {
        <div class="images">
          @for (imageId of imageIds; track imageId) {
            <button
              type="button"
              class="image-container"
              [class.selected]="!!selected && selected == imageId"
              (click)="select(imageId)"
            >
              <media-image [imageId]="imageId"></media-image>
            </button>
          }
        </div>

        @if (canLoadMore) {
          <div class="load-more-row">
            <button
              mat-stroked-button
              color="primary"
              [disabled]="isLoadingMore"
              (click)="loadMore()"
            >
              Show 10 more
            </button>
          </div>
        }
      } @else {
        <div class="empty-state">
            <div class="empty-title">No media found</div>
            <div class="empty-copy">Try another search phrase or sorting option.</div>
            @if (!isPickerMode && !searchTerm.trim()) {
              <button mat-stroked-button color="primary" (click)="openAddMediaDialog()">
                Add media
              </button>
          }
        </div>
      }
    </div>
  </div>
</div>
